import palette from '../palette';
import shadows from '../shadows';

const muiTableRowOverrides = {
  styleOverrides: {
    root: {
      height: '56px',
      boxShadow: shadows.main,
      background: 'white',

      '&$selected': {
        backgroundColor: palette.background.default,
      },
      '&$hover': {
        '&:hover': {
          backgroundColor: palette.background.default,
        },
      },
    },
  },
};

export default muiTableRowOverrides;
